import { React, useState } from "react";

import {
  Grid,
  Typography,
  Paper,
  useTheme,
  Box,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Link,
  InputAdornment,
  FormControl,
  IconButton,
  InputLabel,
  Input,
} from "@mui/material";
import { Route, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

//user Imports

import { NAV_ROUTES, ADMIN_ROUTES } from "../../Services/Routes/App";
import { MainRoutes } from "../../Services/Routes/App";
import { addvalidation } from "../../Services/validation/login";
import { Formik, Form } from "formik";
import { getDecodedToken } from "../../Services/Routes/App/PrivateRouts";
import { MainUrls } from "../../Services/Routes/API";
import { headersPost } from "../../Services/API";
import { StorageKeys } from "../../Services/Storage";
import { USER_ROLES_ENUM } from "../../Services/Enums";
import { LimospayIcon, LimospayTextIcon } from "../../Svg";
import ForgetPassword from "../ForgetPassword";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

//constants

const initialValues = {
  email: "",
  password: "",
};

//styling

const useStyles = makeStyles({
  flexSetting: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
});

const Login = () => {
  // theme

  const theme = useTheme();

  const classes = useStyles();

  //navigate

  const navigate = useNavigate();

  // States

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [showPassword, setShowPassword] = useState(false);

  // add Hanler

  const addHandler = () => {
    navigate(MainRoutes?.signup);
  };
  const addHandler2 = () => {
    navigate(NAV_ROUTES?.dashboard);
  };

  const forgetPasswordHandler = () => {
    navigate(NAV_ROUTES?.forgot_Password);
  };

  const getUrl = (token) => {
    const user = getDecodedToken(token);

    if (user) {
      switch (user.role) {
        case USER_ROLES_ENUM.user:
          navigate(NAV_ROUTES?.dashboard);
          break;
        case USER_ROLES_ENUM.admin:
          navigate(ADMIN_ROUTES?.dashboard);
          break;

        default:
          navigate(MainRoutes?.root);
          break;
      }
    }
  };
  const submitHandler = (values) => {
    const data = {
      user: {
        email: values?.email,
        password: values?.password,
      },
    };
    setOpen(true);

    headersPost(MainUrls?.login, data)
      .then((res) => {
        setOpen(false);

        if (res?.status === 200 && res?.data?.success) {
          const token = res?.data?.token;
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          localStorage.setItem(StorageKeys?.token, token);
          getUrl(token);
        } else {
          localStorage.clear();
          setAlertMsg(res?.data?.message);
          setAlertOpen(true);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        setOpen(false);
        setAlertOpen(true);
        setAlertMsg(response?.statusText);
        setAlertIcon("warning");
        localStorage.clear();
        navigate(MainRoutes?.root);
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  return (
    <Box>
      <Grid container>
        <Grid
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          sx={{
            // height: "90vh",
            width: "100%",
          }}
        >
          <Box
            display={"flex"}
            // justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            // height={"100%"}
            width={"100%"}
            margin={"auto"}
          >
            <Box mt={10}>
              <LimospayIcon />
            </Box>
            <Typography
              margin={"auto"}
              mt={2}
              color={"text.grayText"}
              fontWeight="bold"
              variant="h4"
              display={"flex"}
              width={"55%"}
              height={"55%"}
              alignItems={"center"}
            >
              Providing secure Payment Infrasture
            </Typography>

            <Typography
              margin={"auto"}
              mt={5}
              color={"text.grayText"}
              variant="subtitle"
              display={"flex"}
              width={{ xs: "70%", sm: "60%", md: "55%" }}
              height={"55%"}
              alignItems={"center"}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem
              iaculis lectus vitae interdum vestibulum amet urna blandit.
              Scelerisque iaculis auctor nibh justo in pretium. Praesent
            </Typography>
          </Box>
        </Grid>

        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            // height={"100%"}
            width={{ xs: "90%", sm: "70%" }}
            margin={"auto"}
          >
            <Paper
              elevation={1}
              sx={{
                borderTop: `5px solid  ${theme.palette.primary.main}`,
                borderRadius: 1,

                marginTop: 6,
              }}
            >
              <Box className={classes.flexSetting} mt={4}>
                <LimospayTextIcon />
              </Box>
              <Typography
                variant="subtitle2"
                className={classes.flexSetting}
                m="2rem"
              >
                Welcome Back
              </Typography>
              <Typography
                color="#333333"
                mt={3}
                className={classes.flexSetting}
              >
                Login to your Account
              </Typography>
              <Box>
                <Formik
                  initialValues={initialValues}
                  validationSchema={addvalidation}
                  onSubmit={submitHandler}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleSubmit,
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <Box
                        margin={"auto"}
                        width={"80%"}
                        mt={5}
                        fontSize={"15px"}
                      >
                        <TextField
                          name="email"
                          fullWidth
                          variant="standard"
                          label="Email"
                          value={values?.email}
                          error={touched?.email && Boolean(errors?.email)}
                          helperText={touched?.email && errors?.email}
                          onChange={handleChange}
                          sx={{
                            marginBottom: 1,
                          }}
                        ></TextField>

                        <FormControl sx={{ width: "100%" }} variant="standard">
                          <InputLabel htmlFor="standard-adornment-password">
                            Password
                          </InputLabel>
                          <Input
                            id="standard-adornment-password"
                            type={showPassword ? "text" : "password"}
                            value={values.password}
                            onChange={handleChange("password")}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => {
                                    setShowPassword(!showPassword);
                                  }}
                                  // onMouseDown={() => {

                                  //   setShowPassword(
                                  //     showPassword
                                  //       ? showPassword
                                  //       : !showPassword
                                  //   );
                                  // }}
                                  onMouseUp={() => {
                                    setShowPassword(
                                      showPassword
                                        ? !showPassword
                                        : showPassword
                                    );
                                  }}
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>

                        <Link
                          sx={{
                            color: theme.palette.text,
                            cursor: "pointer",
                          }}
                          underline="none"
                          onClick={() => forgetPasswordHandler()}
                        >
                          Forgot Password ?
                        </Link>
                        <Button
                          variant="contained"
                          type="submit"
                          // onClick={() => addHandler2()}
                          fullWidth
                          sx={{
                            marginTop: 2,
                            height: theme.spacing(5),
                          }}
                        >
                          Login
                        </Button>
                      </Box>
                      <Box className={classes.flexSetting} mt={3}>
                        <Typography align="center">
                          Don't have an account?{" "}
                          <Button
                            component={"span"}
                            variant="text"
                            onClick={() => addHandler()}
                            sx={{
                              color: theme.palette.primary.main,
                            }}
                          >
                            Register
                          </Button>
                        </Typography>
                      </Box>
                    </Form>
                  )}
                </Formik>
              </Box>
            </Paper>
          </Box>
        </Grid>
      </Grid>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={alertIcon}
          sx={{
            backgroundColor: theme.palette?.success?.light,
            color: theme.palette.text?.primary,
          }}
        >
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Login;
